import LegalPage from "./LegalPage";

export default function Terms() {
  return <LegalPage docKey="terms" />;
}
